// The routed pages as lazy chunks. App.tsx renders them; the product tour
// preloads the next section's chunk while the user reads the current step, so
// opening it inside the tour never shows a half-loaded page.
const loaders = {
  '/': () => import('@/pages/OverviewPage'),
  '/news': () => import('@/pages/NewsPage'),
  '/calendar': () => import('@/pages/CalendarPage'),
  '/wall-street': () => import('@/pages/WallStreetPage'),
  '/portfolio': () => import('@/pages/PortfolioPage'),
  '/signals': () => import('@/pages/SignalsPage'),
  '/social': () => import('@/pages/SocialPage'),
  '/ai': () => import('@/pages/OrcaAIPage'),
  '/settings': () => import('@/pages/SettingsPage'),
  '/profile': () => import('@/pages/ProfilePage'),
  '/alerts': () => import('@/pages/AlertsPage'),
  '/whales': () => import('@/pages/WhalesPage'),
} as const;
export type RoutePath = keyof typeof loaders;
export const pageLoader = (path: RoutePath) => loaders[path];
/** starts loading a page's chunk (idempotent: the module cache keeps it) */
export const preloadRoute = (path: string) => { void (loaders as Record<string, () => Promise<unknown>>)[path]?.(); };
